/**
 * 充电用户管理 接口
 */
import {
   deleteRequest,
   putRequest,
   getRequest,
   postRequest,
} from "../../utils/api";

export const apiListChargeAgent = (data) => {
   return postRequest('/api/chargeAgent/list?page='+data.page+'&size='+data.size, data)
}

export const apiSaveChargeAgent = (data) => {
   return postRequest('/api/chargeAgent/update', data)
}
export const apiAddChargeAgentStation = (data) => {
   return postRequest('/api/push-platform/addStation', data)
}

export const apiGetChargeAgent = (id) => {
   return postRequest('/api/chargeAgent/selectById',{id:id})
}

export const apiListStations = (data) => {
   // data.page=1;
   // data.size=9999;
   return postRequest('/api/charge-station/list', data)
}

export const apiListPushPlatform= ()=>{
   return postRequest('/api/push-platform/list',{})
}
